import { render, staticRenderFns } from "./TournamentOfficialPanel.vue?vue&type=template&id=c328c8e6&"
import script from "./TournamentOfficialPanel.vue?vue&type=script&lang=js&"
export * from "./TournamentOfficialPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports